var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", [_vm._v("\n\t\t" + _vm._s(_vm.event.title) + "\n\t")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "events-list" },
        _vm._l(_vm.event.child_events, function (childEvent, index) {
          return _c("event-panel", { key: index, attrs: { event: childEvent } })
        }),
        1
      ),
      _vm._v(" "),
      _c("validation-observer", { ref: "multiRegObserver" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("h2", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("event_registration.title")) +
                    "\n\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "event_registration.please_complete_you_registration"
                      )
                    ) +
                    "\n\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t("event_registration.once_registration_is_complete")
                    )
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "event_registration.once_registration_is_complete2"
                      )
                    ) +
                    "\n\t\t\t\t\t"
                ),
                _c(
                  "a",
                  { attrs: { href: "mailto:events@world-architecs.com" } },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\tevents@world-architecs.com\n\t\t\t\t\t\t"
                    ),
                    _c("i", {
                      staticClass: "wa-arrow wa-arrow-right wa-arrow-small",
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("event-attendees", { attrs: { attendees: _vm.attendees } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _vm._v("\n\t\t\t\t \n\t\t\t"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._v("\n\t\t\t\t \n\t\t\t"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "checkbox checkbox-default" },
              [
                _c("validation-provider", {
                  attrs: { rules: { required: { allowFalse: false } } },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ failedRules }) {
                        return [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tosAccepted,
                                expression: "tosAccepted",
                              },
                            ],
                            attrs: { type: "checkbox", id: "tos", name: "tos" },
                            domProps: {
                              checked: Array.isArray(_vm.tosAccepted)
                                ? _vm._i(_vm.tosAccepted, null) > -1
                                : _vm.tosAccepted,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.tosAccepted,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.tosAccepted = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.tosAccepted = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.tosAccepted = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tos" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("event_registration.tos_label_part1")
                                ) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openLegalModal.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("common.tos")) + " "),
                                _c("i", {
                                  staticClass: "wa-arrow wa-arrow-small",
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("event_registration.tos_label_part2")
                                ) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: _vm.tosLink, target: "_blank" },
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("common.privacy")) + " "),
                                _c("i", {
                                  staticClass: "wa-arrow wa-arrow-small",
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input-errors", {
                            attrs: { errors: failedRules },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "checkbox checkbox-default" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.wantsNewsletter,
                    expression: "wantsNewsletter",
                  },
                ],
                attrs: { type: "checkbox", id: "special-mailings" },
                domProps: {
                  checked: Array.isArray(_vm.wantsNewsletter)
                    ? _vm._i(_vm.wantsNewsletter, null) > -1
                    : _vm.wantsNewsletter,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.wantsNewsletter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.wantsNewsletter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.wantsNewsletter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.wantsNewsletter = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "special-mailings" } }, [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "event_registration.information_about_future_events"
                      )
                    ) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("validation-provider", {
                  attrs: { rules: { required: { allowFalse: false } } },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ failedRules }) {
                        return [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedEventsCount,
                                expression: "selectedEventsCount",
                              },
                            ],
                            attrs: {
                              type: "hidden",
                              id: "events-selected-count",
                            },
                            domProps: { value: _vm.selectedEventsCount },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.selectedEventsCount = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("input-errors", {
                            attrs: { errors: failedRules },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { id: "submit-button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("common.submit", {})) +
                    "\n\t\t\t\t"
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md6" }, [
            _vm._v("\n\t\t\t\t \n\t\t\t"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("event-registration-agreement-modal", { attrs: { event: _vm.event } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }